export enum EstateSignUpMetaType {
  ESTATE_SIGN_UP_FINANCIAL_ADVISOR_META = 'EstateSignUpFinancialAdvisorMeta'
}
